const Styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  fullScreenCalendarContainerStyle: {
    width: '50%',
    zIndex: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh'
  },
  halfScreenCalendarContainerStyle: {
    width: '100%',
    zIndex: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh'
  },
  bookingsContainer: {
    flexDirection: 'column',
    width: '50%',
    zIndex: 200,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '100vh'
  },
  schemeContainerStyle: {
    display: 'flex',
    flexDirection: 'column'
  },
  backgroundFadeStyle: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    width: '100%',
    minHeight: '100%',
    position: 'absolute',
    zIndex: 900,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  currentContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  HEADER_STYLE: {
    marginTop: 100,
    fontSize: 24,
    marginLeft: '5%'
  },
  paperContainer: {
    width: '90%',
    marginBottom: 15,
    padding: 10,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  innerPaperContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  icon: {
    fontSize: 24
  },
  text: {
    margin: 0
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/bookingSystems/BookingSystem/styles.js